import { map } from 'rxjs';
export function toOption({ nameFieldName = 'name', codeFieldName = 'id', }) {
    return (source) => {
        return source.pipe(map((rawValues) => rawValues.map((option) => {
            return {
                name: option[nameFieldName]?.toString() ?? '',
                code: option[codeFieldName]?.toString() ?? '',
            };
        })));
    };
}
